<template>
  <div class="scoped-box">
    <div class="item" v-for="item in list" :key="item.id">
      <Card :title="$t('name.user_bill.title')" :bordered="false" dis-hover>
        <List size="small">
          <ListItem>
            <ListItemMeta :title="$t('name.user_bill.status')" />
            <template slot="extra">
              <span :class="item.status ? 'success' : 'warning'">{{ $t('name.user_bill.status_text')[item.status] }}</span>
            </template>
          </ListItem>
          <ListItem>
            <ListItemMeta :title="$t('name.user_bill.money')" />
            <template slot="extra">
              <span class="money">{{ item.money | money }}</span>
            </template>
          </ListItem>
          <ListItem>
            <ListItemMeta :title="$t('name.user_bill.created_at')" />
            <template slot="extra">
              <Time :time="item.created_at * 1000" type="date" />
            </template>
          </ListItem>
        </List>
      </Card>
    </div>
    <div class="empty" v-if="!list.length">{{ $t('message.empty') }}</div>
  </div>
</template>
<script>
export default {
  props: {
    list: Array
  }
};
</script>
<style lang="less" scoped>
  @import '@/style/app.less';
  
  .scoped-box{
    display: flex;
    flex-wrap: wrap;
    padding: 15px;
    
    .item{
      width: 25%;
      padding: 15px;
    }
    .money{
      color: @color;
      font-size: 16px;
    }
    .warning{
      color: @color-warning;
    }
    .success{
      color: @color-success;
    }
    
    .empty{
      padding: 50px;
      text-align: center;
      width: 100%;
    }
  }
</style>